import { render, staticRenderFns } from "./CreateOilTracker.vue?vue&type=template&id=e5c785e0&scoped=true"
import script from "./CreateOilTracker.vue?vue&type=script&lang=js"
export * from "./CreateOilTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c785e0",
  null
  
)

export default component.exports